module.exports = __webpack_public_path__ + "static/media/sweet_7.8112c893.png";